<template>
<div 
  v-show="visible && commandType" 
  class="contextMenu" 
  id="editorContextMenu" 
  :style="{'left': `${posX}px`, 'top': `${posY}px`}" 
  @contextmenu="browserContextMenuLock"
  ref="contextMenu" 
>
  <ul v-if="!multiSlctBln">
    <li v-if="showReName" v-show="commandType" @click="changName">이름변경하기</li>
    <li v-if="showReName" class="gap"></li>
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" v-show="commandType" @click="addChild">하위노드 추가하기</li>
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" v-show="commandType" @click="addSibling">형제노드 추가하기</li>
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" class="gap"></li>
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" v-show="commandType" @click="selectionDelete">선택한 노드 삭제</li>
    <!-- <li v-show="commandType" @click="noneSelectionDelete">선택하지 않은 노드 삭제</li> -->
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" class="gap"></li>
    <li v-show="commandType" @click="selectionPublicInactive">선택한 노드 비공개</li>
    <!-- <li v-show="commandType" @click="noneSelectionPublicInactive">선택하지 않은 노드 비공개</li> -->
    <li v-show="commandType" @click="selectionPublicActive">선택한 노드 공개</li>
    <!-- <li v-show="commandType" @click="noneSelectionPublicActive">선택하지 않은 노드 공개</li> -->
    <li v-if="treeMode != 'templeteEdit'" class="gap"></li>
    <li v-if="treeMode != 'templeteEdit'" v-show="commandType" @click="memoHandler">{{ memoBln ? memoStr[0] : memoStr[1] }}</li>
  </ul>

  <ul v-if="multiSlctBln">
    <!-- <li v-show="commandType" @click="noneSelectionDelete">선택하지 않은 노드 삭제</li> -->
    <li v-if="treeMode == 'templeteEdit' || treeMode == 'templete'" v-show="commandType" @click="selectionDelete">선택한 노드 삭제</li>
    <li v-if="treeMode == 'templeteEdit'" class="gap"></li>
    <li v-show="commandType" @click="selectionPublicInactive">선택한 노드 비공개</li>
    <!-- <li v-show="commandType" @click="noneSelectionPublicInactive">선택하지 않은 노드 비공개</li> -->
    <li v-show="commandType" @click="selectionPublicActive">선택한 노드 공개</li>
    <!-- <li v-show="commandType" @click="noneSelectionPublicActive">선택하지 않은 노드 공개</li> -->
  </ul>
</div>
</template>

<script>
import AcListComm from '@AccordionList/AcListComm'; 
import { commNewMapMutations , commNewMapGetters } from "@processEditor/CommNew";
import { createNamespacedHelpers } from 'vuex';
import GO from "gojs";
import { v4 } from "uuid";

const ProcessEditor = createNamespacedHelpers('ProcessEditor');
const goMake = GO.GraphObject.make;

export default {
  mixins : [ AcListComm ] , 
  props : {
    crntObj : Object , 
    renameNodeObj : Object , 
    addChildNodeObj : Object , 
    addSiblingNodeObj : Object , 
    memoObj : Object , 
    treeMode : String,
  } , 
  data () {
    return {
      multiSlctBln : false , 

      showReName : false,

      visible: false,
      contextMenu:{},
      posX:0, 
      posY:0,
      command: {},
      diagram: {},
      selectList: [],
      commandType: true,
      tagCommands: {} , 

      memoBln : true , 
      memoStr : [ '메모 작성하기' , '메모 삭제하기' ] , 
    }
  },
  watch : {
    'crntObj.obj.confirm' : {
      immediate : true , 
      handler ( confirm ) {
        if ( !confirm ) return ; 
        // console.log( 'this.crntObj.slotName : ' , this.crntObj.slotName ) ; 

        switch ( this.crntObj.slotName ) {
          case 'sibling' :  
            this.addSiblingFunc() ; 
            break ; 
          case 'child' : 
            this.addChildFunc() ; 
            break ; 
          case 'rename' : 
            this.changNameFunc() ; 
            break ; 
        }
      } , 
    } , 
    /* memoObj : {
      handler ( memoObj ) {
      } , 
    } ,  */
    getTagInfoCommand (value) {
      this.tagCommands = value
    }
  },
  created() {
    
  },
  mounted () {
    // console.log(this.crntObj)

    this.contextMenu = goMake(GO.HTMLInfo, {
      show: this.showContextMenu,
      hide: this.hideContextMenu,
    })
    this.$emit('contextMounted', this.contextMenu)
  },
  computed : {
    ...commNewMapGetters([
      'protocolIssueList' , 
      'crntProtocolInfo' , 
      'PROCESS_INFO' , 
      'crntProtocolInfo' , 
    ]) , 
    ...ProcessEditor.mapGetters(['getTagInfoCommand']),
  },
  methods: {
    ...commNewMapMutations([
      'setCrntDiagram' , 
      'updateProtocols' , 
    ]),
    ...ProcessEditor.mapMutations(['selectNode']),
    browserContextMenuLock (e) {
      e.preventDefault();
      return false;
    },
    showContextMenu (obj, diagram, tool) {
      let viewportBounds, contextSize
      let {x, y} = diagram.lastInput.viewPoint
      let scale = diagram.scale
      this.selectList = []
      this.diagram = diagram
      this.command = diagram.commandHandler
      this.setCrntDiagram( diagram ) ; 
      /* if(this.diagram.selection.size > 1) {
        window.wToast("여러 개의 태그 선택 시 컨텍스트 메뉴는 사용할 수 없습니다.", {
          variant: "red",
        });
        return
      } */

      this.multiSlctBln = this.diagram.selection.size > 1 ? true : false ; 

      this.diagram.selection.each( (item)=>{
        // console.log( 'temporaryText : ' , item.data.temporaryText ) ; 
        if ( item.data.temporaryText ) {
          this.memoBln = false ; 
          // console.log( 'item.data.temporaryText : ' , item.data.temporaryText ) ; 
        } else {
          this.memoBln = true ; 
        }
        this.selectList.push(item);
      } )

      if( this.selectList.length === 0 ) return;

      if( this.treeMode != "templeteEdit" && ( !this.multiSlctBln && this.selectList[0].data.D ) ){
        this.showReName = true;
      }else{
        this.showReName = false;
      }

      if(this.selectList.length === 0) this.commandType = false
      else this.commandType = true

      this.$refs.contextMenu.style.visibility = 'hidden' ; 
      this.visible = true
      setTimeout(_=>{
        contextSize = this.$refs.contextMenu.getBoundingClientRect()
        viewportBounds = this.diagram.viewportBounds
        this.posY = Math.min( viewportBounds.height*scale - contextSize.height - 10, y)
        this.posX = Math.min(viewportBounds.width*scale - contextSize.width - 10, x);
        this.$refs.contextMenu.style.visibility = 'visible' ; 
      }) ; 
    },
    hideContextMenu (obj, diagram, tool) {
      // console.log('Hide context menu')
      this.visible = false
    },
    clearContextMenu () {
      if (this.diagram.currentTool instanceof go.ContextMenuTool) {
        this.diagram.currentTool.doCancel();
      }
      this.visible = false
    },
    changName () {
      const node = this.diagram.selection.first().data;
      this.crntObj.updateHandler({ type : 'rename' , openBln : true, text : node.text }) ; 
      this.clearContextMenu()
    },
    changNameFunc () { 
      if ( this.crntObj.obj.diagram ) {
        this.diagram = this.crntObj.obj.diagram ; 
      } 

      if ( this.diagram.selection === undefined ) return ; 
      if ( this.diagram.selection.size !== 1 ) return ; 

      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 

        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 

        this.diagram.selection.each(( node )=>{
          this.diagram.model.set( node.data , 'text' , this.crntObj.obj.text ) ; 
          this.diagram.model.nodeDataArray.map( nodeInfo => {
            if ( nodeInfo.key == node.key ) {
              nodeInfo.text = this.crntObj.obj.text ; 
            }
          }) ; 
          
          slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
          // console.log({
          //   'slctProtocol.json' : slctProtocol.json , 
          // })
          this.updateProtocols( protocols ) ; 
        }) ; 
      }

      this.crntObj.updateHandler({ type : this.crntObj.slotName , confirm : false }) ; 
    } , 
    addChild () {
      // console.log('Add child : ')
      this.crntObj.updateHandler({ type : 'child' , openBln : true }) ; 
      this.clearContextMenu() ; 
    } , 
    addChildFunc () {
      if ( this.diagram.selection === undefined ) return ; 
      if ( this.diagram.selection.size !== 1 ) return ; 

      // console.log( 'this.crntObj.obj : ' , this.crntObj.obj ) ; 

      this.diagram.selection.each((node)=>{
        let {key, protocolId, text} = node.data ; 
        const childData = {
          category : 'CHILD' , 
          key : v4() , 
          parent : key , 
          protocolId : protocolId , 
          text : this.crntObj.obj.text , 
          visible : false , 
        }

        this.diagram.model.addNodeData( childData )
      }) ; 

      this.crntObj.updateHandler({ type : this.crntObj.slotName , confirm : false }) ; 

      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 

        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
        slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
        // console.log( '// ==> slctProtocol.json : ' , JSON.parse( slctProtocol.json )) ; 

        let crntIdx = 0 ; 
        protocols.map(( protocol , idx ) => {
          if ( protocol.keyOfProtocol == protocolId ) crntIdx = idx ; 
        }) ; 

        this.updateProtocols( protocols ) ; 
      }
    } , 

    addSibling () {
      this.crntObj.updateHandler({ type : 'sibling' , openBln : true }) ; 
      this.clearContextMenu() ; 
      // 형제노드 추가시 watch -> 'crntObj.obj.confirm' 을 바라본다. 
    } , 
    addSiblingFunc () {
      if ( this.diagram.selection === undefined ) return ; 
			if ( this.diagram.selection.size !== 1 ) return ; 

      this.diagram.selection.each((node, data)=>{
				let {parent, protocolId, text} = node.data

        // console.log( this.diagram.findNodeForKey( node.data.key )) ; 
        // console.log( this.diagram.findNodeForKey( node.data.parent )) ; 
        // console.log( 'node.data : ' , node.data ) ; 
        // console.log( 'addSiblingFunc' , {
        //   parent , 
        //   protocolId , 
        // }) ; 

        const childData = {
					category : 'CHILD' , 
					key : v4() , 
          parent , 
          protocolId , 
          text : this.crntObj.obj.text , 
          visible : false , 
        } ; 
				
				this.diagram.model.addNodeData( childData )
      }) ; 

      this.crntObj.updateHandler({ type : this.crntObj.slotName , confirm : false }) ; 

      // console.log( 'this.protocolIssueList : ' , this.protocolIssueList ) ; 
      // console.log( 'this.crntProtocolInfo : ' , this.crntProtocolInfo ) ; 
      // console.log( 'this.crntProtocolInfo : ' , this.crntProtocolInfo.parent ) ; 
      // console.log( 'this.diagram.model.nodeDataArray : ' , this.diagram.model.nodeDataArray ) ; 
      // console.log( 'this.PROCESS_INFO : ' , this.PROCESS_INFO ) ; 
      // console.log( 'this.crntProtocolInfo : ' , this.crntProtocolInfo ) ; 
      // console.log( 'this.$route.query : ' , this.$route.query ) ; 
      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 

        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
        // console.log( '==> slctProtocol.json : ' , slctProtocol.json ) ; 

        slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
        // console.log( '// ==> slctProtocol.json : ' , JSON.parse( slctProtocol.json )) ; 

        let crntIdx = 0 ; 
        protocols.map(( protocol , idx ) => {
          if ( protocol.keyOfProtocol == protocolId ) crntIdx = idx ; 
        }) ; 

        this.updateProtocols( protocols ) ; 
      }

    } , 

     selectionPublicActive () {
      this.diagram.selection.each(( node )=>{
        delete node.data.H; 
        node.isSelected = false ; 
      }) ; 

      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 
        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
        slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
        this.updateProtocols( protocols ) ; 
      }

      this.clearContextMenu() ; 
    } , 
    
    selectionPublicInactive () {
      this.diagram.selection.each(( node )=>{
        node.data.H = true;
        node.isSelected = false ; 
      }) ; 

      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 
        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
        slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
        this.updateProtocols( protocols ) ; 
      }

      this.clearContextMenu() ; 
    } , 
    
    noneSelectionPublicActive () {
      this.diagram.selection.each(( node )=>{
        let { data } = node ; 
        let arr = [] ; 
        console.log( 'data : ', data ) ; 
        this.diagram.model.nodeDataArray.map( nodeData => {
          if ( data.parent == nodeData.parent && data.key != nodeData.key ) {
            let chkNode = this.diagram.findNodeForKey( nodeData.key ) ; 
            console.log( 'chkNode : ' , chkNode )
            arr.push( chkNode ) ; 
          }
        }) ; 

        this.diagram.selectCollection( arr ) ; 
        this.diagram.selection.each( node => {
          delete node.data.H; 
          node.isSelected = false ; 
        }) ; 

        if( this.treeMode != "templeteEdit" ){
          let { protocols } = this.PROCESS_INFO ; 
          let { protocolId } = this.$route.query ; 
          const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
          slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
          this.updateProtocols( protocols ) ; 
        }

        this.clearContextMenu() ; 
      }) ; 

      this.clearContextMenu() ; 
    } ,

    noneSelectionPublicInactive () {
      this.diagram.selection.each(( node )=>{
        let { data } = node ; 
        let arr = [] ; 
        console.log( 'data : ', data ) ; 
        this.diagram.model.nodeDataArray.map( nodeData => {
          if ( data.parent == nodeData.parent && data.key != nodeData.key ) {
            let chkNode = this.diagram.findNodeForKey( nodeData.key ) ; 
            console.log( 'chkNode : ' , chkNode )
            arr.push( chkNode ) ; 
          }
        }) ; 

        this.diagram.selectCollection( arr ) ; 
        this.diagram.selection.each( node => {
          node.data.H = true; 
          node.isSelected = false ; 
        }) ; 

        if( this.treeMode != "templeteEdit" ){
          let { protocols } = this.PROCESS_INFO ; 
          let { protocolId } = this.$route.query ; 
          const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
          slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
          this.updateProtocols( protocols ) ; 
        }

        this.clearContextMenu() ; 
      }) ; 

      this.clearContextMenu() ; 
    } , 

    selectionDelete () {
      // >> 삭제로그 필요시 open > insert 동작 확인 필요.
      // let { protocols } = this.PROCESS_INFO ; 
      // let { protocolId } = this.$route.query ; 
      // const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
      // slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
      
      // 삭제시 해당 노드가 유닛프로토콜인지 확인 후 로그를 남긴다.
      // this.diagram.selection.each(  async (node) => {
      //   if(node.data.unit === true){
      //     await this.$wApi.protocol.unit.deleteLog({
      //         fullProtocolId		:	slctProtocol.id,
      //         unitProtocolId	    :	node.data.unitProtocolId,
      //     });
      //   }
      // });
      
      this.command.deletesTree = true ; 
      this.command.deleteSelection() ; 
      this.command.deletesTree = false ; 

      if( this.treeMode != "templeteEdit" ){
        let { protocols } = this.PROCESS_INFO ; 
        let { protocolId } = this.$route.query ; 
        const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
        slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 

        // console.log( '--> json : ' , this.diagram.model.nodeDataArray , protocolId ) ; 

        this.updateProtocols( protocols ) ; 
      }

      this.clearContextMenu() ; 
    } , 

    noneSelectionDelete () {
      let { protocols } = this.PROCESS_INFO ; 
      let { protocolId } = this.$route.query ; 

      const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 

      console.log(' slctProtocol :  ' , slctProtocol ) ; 
      // const { issues } = JSON.parse( slctProtocol.json ) ; 
      const { issues } = slctProtocol.json ; 
      
      // this.diagram.select( ["issue-0336ae54-5a1b-4cd7-a92d-8c1c203b4f81" , "issue-3e2b4684-2665-4c85-8c90-f06e65c3562f"] ) ; 
      // console.log( 'this.diagram.selection : ', this.diagram.selection ) ; 
      // console.log( 'this.diagram.selection.size : ', this.diagram.selection.size ) ; 

      this.diagram.selection.each(( node )=>{
        let { data } = node ; 
        let arr = [] ; 
        console.log( 'data : ', data ) ; 
        issues.map( nodeInfo => {
          if ( data.parent == nodeInfo.parent && data.key != nodeInfo.key ) {
            let chkNode = this.diagram.findNodeForKey( nodeInfo.key ) ; 
            console.log( 'chkNode : ' , chkNode )
            arr.push( chkNode ) ; 
          }
        }) ; 

        this.diagram.selectCollection( arr ) ; 
        this.diagram.selection.each(({ data : dataNew })=>{
          // console.log( 'dataNew : ' , dataNew )
        }) ; 

        this.command.deletesTree = true ; 
        this.command.deleteSelection() ; 

        this.command.deletesTree = false ; 

        if( this.treeMode != "templeteEdit" ){
          let { protocols } = this.PROCESS_INFO ; 
          let { protocolId } = this.$route.query ; 
          const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
          slctProtocol.json = JSON.stringify({ issues : this.diagram.model.nodeDataArray }) ; 
          this.updateProtocols( protocols ) ; 
        }
      }) ; 
      this.clearContextMenu() ; 
    } , 
    memoHandler () {
      console.log(' memoHandler in' ) ; 

      if ( this.memoBln ) {
        // console.log('a') ; 
        this.memoObj.initHandler() ; 
      } else {
        // console.log('b') ; 

        this.diagram.selection.each(( node )=>{
          console.log( node.data.key  ) ; 
          console.log( node.data  ) ; 
          this.memoObj.deleteHandler({ 
            tagKey : node.data.key , 
            protocolId : node.data.protocolId , 
          }) ; 
        }) ; 

      }

      console.log('c') ; 

      this.clearContextMenu() ; 
    }
  }
}
</script>

<style lang="scss">
.contextMenu {
  position: absolute; top: 0; left:0;
  min-width: 135px;
  z-index: 10;
  background-color: #fff;;
  visibility: hidden; 
  cursor: pointer;
  ul {
    padding: 8px;
    border: 1px solid #999;
    li {
      padding: 8px;
      font-size: 14px;
      @include text-prt-sb;
      &:hover {
        background: #eee;
      }

      &.gap {
        height: 1px; 
        background-color: $gray-d; 
        padding: 0; 
        margin: 4px 8px; 
      }
    }
  }
}
</style>